import { render } from "./SupermarketInterview.vue?vue&type=template&id=4224c2b4&scoped=true"
import script from "./SupermarketInterview.vue?vue&type=script&lang=js"
export * from "./SupermarketInterview.vue?vue&type=script&lang=js"

import "./SupermarketInterview.vue?vue&type=style&index=0&id=4224c2b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4224c2b4"]])

export default __exports__